import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  WalletService,
  AccountWalletDetails,
  WalletStatusTypeEnum,
  CustomerService,
} from '@cai-services';
import { environment } from '../../../../environments/environment';
import { APP_PROPS } from '../../../../cai-common.module';
import { ApplicationProperties } from '../../../../core/_base/layout/models/app-properties.model';
import { WalletUtil } from '../../../../utils';
import { Office } from '../../../../core/_models/office.model';

@Component({
  selector: 'kt-wallet-status',
  templateUrl: './wallet-status.component.html',
  styleUrls: ['./wallet-status.component.scss'],
  standalone: false,
})
export class WalletStatusComponent implements OnChanges {
  @Input() title: string;
  @Input() tag: string;
  @Input() status: WalletStatusTypeEnum;
  @Input() showActivateButton: boolean;
  @Input() showAddWalletButton: boolean;
  @Input() showAdditionalButton: boolean;
  @Input() showStatus: boolean;
  @Input() description: string;
  @Input() titleToolTipHeader?: string;
  @Input() titleToolTipMessage?: string;
  @Input() titleToolTipFooter?: string;
  @Input() titleToolTipPlacement?: any;
  @Input() titleToolTipWidth?: number;
  @Input() enablePopover = true;
  @Input() isPageReady = false;
  @Input() walletDetails: AccountWalletDetails;
  @Input() canViewBalance: boolean;
  @Input() selectedOffice: Office;
  @Output() defaultBalanceChange = new EventEmitter<string>();
  @Output() showWalletActivationForm = new EventEmitter<boolean>();
  WalletTypeEnum = WalletStatusTypeEnum;
  walletActivationLink: string = environment.walletConfig?.walletActivationLink;
  globalPrepaidBalance = '0';
  selectedOfficeId: number;
  getCurrencySymbol = WalletUtil.getCustomCurrencyCode;
  starterTitle = $localize`:@@limit-access-starter:Limited access as a “Starter” role`;
  starterDescription = $localize`:@@limit-access-starter-wallet-management:Your current role has limited permissions. To view balances and gain additional access, please contact your Office Admin.`;

  constructor(
    @Inject(APP_PROPS)
    private readonly appProperties: ApplicationProperties,
    private readonly walletService: WalletService,
    private readonly customerService: CustomerService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  async ngOnChanges(): Promise<void> {
    if (
      this.status &&
      this.walletDetails &&
      (!this.globalPrepaidBalance ||
        this.walletDetails.office_id != this.selectedOfficeId?.toString() ||
        this.isCargoWallet)
    ) {
      await this.getDefaultCurrencyTotal();
    }
  }
  async getDefaultCurrencyTotal(currency?: string): Promise<void> {
    this.selectedOfficeId = this.selectedOffice?.id;
    const officeId = this.selectedOfficeId?.toString();
    let getGlobalPrepaidBalance$;
    if (this.isCargoWallet) {
      getGlobalPrepaidBalance$ = this.customerService.getGlobalPrepaidBalance(
        this.selectedOffice.walletId,
        currency ?? this.walletDetails.default_currency,
      );
    } else {
      getGlobalPrepaidBalance$ = this.walletService.getGlobalPrepaidBalance(
        officeId,
        currency ?? this.walletDetails.default_currency,
      );
    }

    this.globalPrepaidBalance = (
      (await getGlobalPrepaidBalance$)?.amount ?? 0
    ).toString();
    this.cdr.detectChanges();
  }
  get getWalletStatusString(): string {
    return this.status?.toString();
  }

  get activationLink(): string {
    if (!this.selectedOfficeId) {
      this.selectedOfficeId = this.selectedOffice?.id;
    }

    return this.walletActivationLink + '?id=' + this.selectedOfficeId;
  }

  async onSetDefaultCurrency(currency: string) {
    if (this.tag == 'PAYLATER') {
      return;
    }

    const officeId = this.selectedOffice?.id?.toString();
    if (this.isCargoWallet) {
      await this.customerService.patchDefaultBalance(
        this.walletDetails.customer_id,
        this.selectedOffice.walletId,
        currency,
      );
    } else {
      await this.walletService.patchDefaultBalance(officeId, currency);
    }
    await this.getDefaultCurrencyTotal(currency);
    this.defaultBalanceChange.emit(currency);
  }
  get defaultCurrencyTooltip(): string {
    return $localize`:@@wallet.default-currency-tooltip:Among the currencies you have on your balance, you can choose the currency you want to assign as CargoWALLET <b>Default Currency</b>. The <b>Default Currency</b> is the ''Prepaid Estimated Balance'' currency.`;
  }
  get defaultGlobalSumTooltip(): string {
    return $localize`:@@wallet.default-global-sum-tooltip:The ''Prepaid Estimated Balance'' is an <b>estimated</b> sum of all the ''Prepaid Balances'' converted into the ''CargoWALLET Default currency''`;
  }

  get walletBaseUrl(): string {
    return this.appProperties.walletBaseUrl;
  }

  get isCargoWallet(): boolean {
    return this.appProperties.name === 'cargowallet';
  }
}
